import script from "./AnalysisPie.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalysisPie.vue?vue&type=script&setup=true&lang=js"

import "./AnalysisPie.vue?vue&type=style&index=0&id=06918dc7&scoped=true&lang=css"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06918dc7"]])

export default __exports__